import { render, staticRenderFns } from "./JokeCard.vue?vue&type=template&id=415fbab8&scoped=true&"
import script from "./JokeCard.vue?vue&type=script&lang=js&"
export * from "./JokeCard.vue?vue&type=script&lang=js&"
import style0 from "./JokeCard.vue?vue&type=style&index=0&id=415fbab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415fbab8",
  null
  
)

export default component.exports